// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__q-tTY","rootSuccess":"CompleteLink_rootSuccess__2qSU5","rootFailure":"CompleteLink_rootFailure__1S8Ga","isDisabled":"CompleteLink_isDisabled__1gpr_"};